import StatPageFormContainer from './_StatPageFormContainer';

export default StatPageFormContainer;
